module.exports = __webpack_public_path__ + "static/media/practice-edition-bg-logo.2f002a74.png";